exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dynamic-form.create .add-field{position:relative;z-index:9}.dynamic-form.create .add-field .cbp-tm-menu>li{left:50%;transform:translateX(-50%)}.dynamic-form.create .field-tooltip-trigger-icon{cursor:pointer;border-radius:50%;width:30px;height:30px;display:inline-flex;align-items:center;justify-content:center}.dynamic-form.create .field-tooltip-trigger-icon svg{position:relative;width:17px !important;height:17px !important;top:2px}.dynamic-form.create .field-tooltip-trigger-icon.up svg{transform:rotateX(180deg)}.dynamic-form.create .field-tooltip-trigger-icon:hover{background-color:#e4e4e4}", ""]);

// exports
